"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SmartContractType;
(function (SmartContractType) {
    SmartContractType[SmartContractType["EscrowSmartContract"] = 0] = "EscrowSmartContract";
})(SmartContractType = exports.SmartContractType || (exports.SmartContractType = {}));
var SmartContractTokenType;
(function (SmartContractTokenType) {
    SmartContractTokenType["ERC20"] = "erc20";
    SmartContractTokenType["ETHER"] = "ether";
})(SmartContractTokenType = exports.SmartContractTokenType || (exports.SmartContractTokenType = {}));
var EscrowState;
(function (EscrowState) {
    EscrowState[EscrowState["NON_EXISTENT"] = 0] = "NON_EXISTENT";
    EscrowState[EscrowState["OPEN"] = 1] = "OPEN";
    EscrowState[EscrowState["CLAIMED"] = 2] = "CLAIMED";
    EscrowState[EscrowState["ABORTED"] = 3] = "ABORTED";
})(EscrowState = exports.EscrowState || (exports.EscrowState = {}));
//# sourceMappingURL=definitions.js.map